import { Component, ElementRef, ViewChild } from "@angular/core";
import { DataBroker } from "@ponder-core/data/dataBroker";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { environment } from "../../../../environments/environment";

@Component({
    imports: [],
    templateUrl: "./about.component.html",
    styles: ["a { color: rgb(189, 147, 249); }", "a:hover { color: rgb(247, 202, 255); }"]
})
export class AboutComponent {
    private static readonly ponderIds: string[] = [
        "066be14e-3b24-71dd-8000-d7bacd26a524",
        "01902fa9-1cc6-7439-9f5d-ca09374ea2b4",
        "019008c5-8782-7c46-b5e3-10cd650445d2",
        "01902ca4-bb39-7dae-8b39-1115d91b140a",
        "01902df2-9e15-768b-8279-edf8e3e903b9",
        "01902fbe-7fe8-7f37-a337-00a07e8187ad",
        "01902d3b-3321-70d1-81b9-85c65e73ac42",
        "01902c7a-67a5-7d64-9380-2bcafe6186f0",
        "01902ffb-707b-7381-8656-40e875a9c32d",
        "066e9d8f-566e-74cf-8000-05c3a30521b2",
        "067a4d44-2d7d-7d88-8000-0b8ed9a90a3d"
    ];

    @ViewChild("contactAnchor") private contactAnchorRef!: ElementRef<HTMLElement>;

    public readonly ponderImageId = AboutComponent.ponderIds[Math.floor(Math.random() * AboutComponent.ponderIds.length)];
    public readonly ponderImageUrl = `${environment.ponderImageBaseUrl}/card/large/front/${this.ponderImageId}.jpg`;

    public constructor(private events: EventBroker, private data: DataBroker) {

    }

    public ngOnDestroy(): void {
        this.events.ui.restoreContentPaddingEvent.emit();
    }

    public ngOnInit(): void {
        this.events.ui.hideNavbarEvent.emit();
        this.events.ui.removeContentPaddingEvent.emit();
    }

    public ngAfterViewInit(): void {
        this.data.ui.requestHeaderHeight.emit((headerHeight: number): void => {
            this.contactAnchorRef.nativeElement.style.top = `-${headerHeight}px`;
        });
    }
}